"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LoadingDots_exports = {};
__export(LoadingDots_exports, {
  default: () => LoadingDots_default
});
module.exports = __toCommonJS(LoadingDots_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 12.3398C9.92708 12.3398 9.43229 12.138 9.01562 11.7344C8.61198 11.3177 8.41016 10.8229 8.41016 10.25C8.41016 9.67708 8.61198 9.1888 9.01562 8.78516C9.43229 8.36849 9.92708 8.16016 10.5 8.16016C11.0729 8.16016 11.5612 8.36849 11.9648 8.78516C12.3815 9.1888 12.5898 9.67708 12.5898 10.25C12.5898 10.8229 12.3815 11.3177 11.9648 11.7344C11.5612 12.138 11.0729 12.3398 10.5 12.3398ZM2.58984 14C2.00391 14 1.50911 13.7982 1.10547 13.3945C0.701823 12.9909 0.5 12.4961 0.5 11.9102C0.5 11.3372 0.701823 10.849 1.10547 10.4453C1.50911 10.0417 2.00391 9.83984 2.58984 9.83984C3.16276 9.83984 3.65104 10.0417 4.05469 10.4453C4.45833 10.849 4.66016 11.3372 4.66016 11.9102C4.66016 12.4961 4.45833 12.9909 4.05469 13.3945C3.65104 13.7982 3.16276 14 2.58984 14ZM18.4102 10.6602C17.8372 10.6602 17.349 10.4583 16.9453 10.0547C16.5417 9.65104 16.3398 9.16276 16.3398 8.58984C16.3398 8.00391 16.5417 7.50911 16.9453 7.10547C17.349 6.70182 17.8372 6.5 18.4102 6.5C18.9961 6.5 19.4909 6.70182 19.8945 7.10547C20.2982 7.50911 20.5 8.00391 20.5 8.58984C20.5 9.16276 20.2982 9.65104 19.8945 10.0547C19.4909 10.4583 18.9961 10.6602 18.4102 10.6602Z",
      fill: "currentColor"
    }
  )
);
const SvgLoadingDots = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LoadingDots_default = SvgLoadingDots;
